<template>

    <user-form
        v-if="loaded"
        :info-url="infoUrl"
        :post-url="postUrl"
        @userChanged="onUpdate"
    ></user-form>

</template>

<script>

import UserForm from "../../../components/Users/Form";
import {mapGetters} from "vuex";

export default {

    components: {
        UserForm,
    },

    computed: {
        ...mapGetters([
            'getHrUser',
        ]),

        infoUrl() {
            let string = this.edit === true ?
                this.route('api.v1.users.info', {user_uuid:this.getHrUser.uuid}) :
                this.route('api.v1.users.info');

            return string.toString();
        },
        postUrl() {
            return this.edit === true ?
                this.route('api.v1.users.post', {user_uuid:this.getHrUser.uuid}) :
                this.route('api.v1.users.post');
        },
    },

    data() {
        return {
            edit:false,
            loaded:false,
        }
    },

    metaInfo: {
        title:'Gebruiker formulier',
    },

    methods: {

        checkForEdit() {
            if (this.$route.params.uuid) {
                this.edit = true;
            }
            this.loaded = true;
        },

        onUpdate(user_uuid) {
            this.$parent.$emit('updateUserData');
            // Move to the users details page.
            this.$router.push({
                name:'hr.users.show',
                params:{
                    uuid: user_uuid,
                },
            });
        },

    },

    mounted(){
        this.checkForEdit();
    },

    name:'HrUsersForm',

}

</script>
